<template>
  <div class="album" style="{width, height}" :class="color + ' ' + size">
    <img :src="(track.image) ? track.image : '/static/images/album.png'" class="album-image" v-on:load="refreshDimentions()" ref="image" />
    <span class="album-info" v-if="!track.image">
      <span class="artists" v-html="artists"></span>
      <span class="title color" v-text="track.title"></span>
    </span>
    <a :href="track.pre_save_spotify" class="pre-save-spotify" v-if="track.pre_save_spotify && size !== 'small'">
      <span class="spotify"></span>
      <strong>Pre-save on Spotify</strong>
      <strong>Pre-save on Spotify</strong>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Album',
  props: ['track', 'size'],
  data () {
    return {
      width: 0,
      height: 0,
      colors: ['green', 'purple', 'pink', 'yellow', 'blue']
    }
  },
  methods: {
    refreshDimentions () {
      this.width = this.$refs.image.clientWidth
      this.height = this.$refs.image.clientHeight
    }
  },
  computed: {
    color () {
      return this.colors[((this.track.title.length) % this.colors.length)]
    },
    artists () {
      var text = this.track.artist.split('&').join('<span class="color"> &</span>')
      return text.split(',').join('<span class="color"> &</span>')
    }
  }
}
</script>

<style lang="scss">
@import '../scss/variables';
.album {
  &.green { .color { color: $green !important; } }
  &.purple { .color { color: $purple !important; } }
  &.pink { .color { color: $pink !important; } }
  &.yellow { .color { color: $yellow !important; } }
  &.blue { .color { color: $blue !important; } }
  position: relative;
  .album-image {
    width: 100%;
  }
  &.large {
    .album-info {
      font-size: 48px;
      .title {
        font-size: 30px;
      }
    }
  }
  &.small {
    .album-info {
      font-size: 8px;
      .title {
        font-size: 5px;
      }
    }
  }
  .album-info {
    position: absolute;
    top: 50%;
    left: 50%;
    color: $white;
    font-size: 28px;
    text-align: center;
    height: auto;
    width: 90%;
    transform: translate(-50%, -50%);
    @media screen and (max-width: 1500px) {
      font-size: 20px;
    }
    .artists {
      font-family: $font-bold;
      width: 100%;
      display: block;
    }
    .title {
      font-size: 25px;
      text-align: center;
      margin-top: 0.3em;
      width: 80%;
      padding: 0 10%;
      display: block;
      @media screen and (max-width: 1500px) {
        font-size: 20px;
      }
    }
  }

  a.pre-save-spotify {
    border: none;
    color: $white;
    padding: 6% 0;
    font-size: 9px;
    font-family: $font-bold;
    outline: none;
    display: block;
    cursor: pointer;
    position: absolute;
    text-indent: -2em;
    text-align: center;
    text-decoration: none;
    bottom: 3vw;
    left: 16%;
    width: 68%;
    transition: color 0.3s linear;

    background: linear-gradient(to bottom, #00ce34 0%, #00ce34 50%, #59ef7f 51%, #59ef7f 100%);
    background-size: 100% 210%;
    transition: background 0.3s $easeOutQuint;

    strong:last-child {
      position: absolute;
      top: 50%;
      left: 0px;
      width: 100%;
      display: block;
      opacity: 0;
      transition: transform 0.3s $easeOutBack, opacity 0.2s linear;
      transform: translate3d(0px, 10px, 0px);
      color: #000;
      opacity: 0;
      pointer-events: none;
    }
    
    strong:first-child {
      transition: transform 0.3s $easeOutBack, opacity 0.2s linear;
      transform: translate3d(0px, 0px, 0px);
      display: block;
      top: 0px;
      position: relative;
    }    


    &:hover {
      background-position: 100% 98%;
      strong:last-child {
        transform: translate(0%, -50%);
        opacity: 1;
      }
      strong:nth-child(2) {
        transform: translate3d(0px, -10px, 0px);
        opacity: 0;
      }      
      .spotify {
        filter: invert(0);
      }
    }
    .spotify {
      background-image: url('/static/images/spotify.svg');
      background-repeat: no-repeat;
      width: 2em;
      height: 2em;
      display: inline-table;
      background-size: cover;
      position: absolute;
      top: 50%;
      right: 20px;
      margin-top: -1em;
      filter: invert(100%);
      transition: filter 0.3s linear;
    }
  }

  @media screen and (min-width: 1700px) {
     a.pre-save-spotify {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 1200px) {
    .album-info {
      font-size: 13px;
      .title {
        font-size: 12px;
      }
    }
    
    a.pre-save-spotify {
      bottom: 5vw;
      font-size: 14px;
      text-indent: 0;
      .spotify {
        display: none;
      }
    }
  }
  
  @media screen and (max-width: 700px) {
     a.pre-save-spotify {
      font-size: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Album.vue